import FullWidthImage from "../../components/Images/image-full-width";

export default function CarouselImagesProduct({ listOfImages = [], onImageClick }) {
    return (
        <div className='mt-4 flex gap-8'>
            {listOfImages.map((img, index) => (
                <div key={index} onClick={() => onImageClick(img)} className="cursor-pointer">
                    <FullWidthImage url={img} className='shadow' />
                </div>
            ))}
        </div>
    );
}